import { FormValidators } from '@servicetitan/form-state';
import { MultipleValidator } from './multiple.validator';

export const createPasswordValidator = () =>
    new MultipleValidator({
        'At least eight characters long': val => val.length < 8,
        'At least one number': val => !/\d/.test(val),
        'At least one lowercase letter(s)': val => !/[a-z]/.test(val),
        'At least one uppercase letter(s)': val => !/[A-Z]/.test(val),
        'At least one special character (ex., !@#$)': val =>
            !'!"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~'.split('').some(el => val.includes(el)),
    });

export const requiredPasswordFieldValidator =
    FormValidators.requiredWithCustomMessage('Enter a password');
